// Aboutページ（/about）
// Q&Aアコーディオンは src/faq.js の .js-faq-* をそのまま利用する。
// ここではSPの「ご登録者様の声」カルーセル（CSSスクロールスナップ）の
// インジケータ同期だけを担当する。
$(function() {
  const viewport = document.querySelector('.js-about-voice-viewport');
  const dotsWrap = document.querySelector('.js-about-voice-dots');
  if (!viewport || !dotsWrap) return;

  const dots = Array.from(dotsWrap.querySelectorAll('.about-voice-dot'));
  const cards = Array.from(viewport.querySelectorAll('.about-voice'));
  if (!dots.length || !cards.length) return;

  // ビューポート中央に最も近いカードを現在位置とみなす
  const currentIndex = function() {
    const center = viewport.scrollLeft + viewport.clientWidth / 2;
    let nearest = 0;
    let min = Infinity;
    cards.forEach(function(card, i) {
      const distance = Math.abs(card.offsetLeft + card.offsetWidth / 2 - center);
      if (distance < min) {
        min = distance;
        nearest = i;
      }
    });
    return nearest;
  };

  const syncDots = function() {
    const active = currentIndex();
    dots.forEach(function(dot, i) {
      dot.classList.toggle('is-active', i === active);
    });
  };

  dots.forEach(function(dot, i) {
    dot.addEventListener('click', function() {
      const card = cards[i];
      viewport.scrollTo({
        left: card.offsetLeft - (viewport.clientWidth - card.offsetWidth) / 2,
        behavior: 'smooth'
      });
    });
  });

  let ticking = false;
  viewport.addEventListener('scroll', function() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function() {
      syncDots();
      ticking = false;
    });
  });

  syncDots();
});
